import { createStore, combineReducers } from 'redux'

function dataStateReducer(state = {}, action) {
  switch (action.type.toLowerCase()) {
    case "data":
      return Object.assign({}, state, {
        [action.key]: action.value
      })
    default:
      return state
  }
}

function configStateReducer(state = {}, action) {
  switch (action.type.toLowerCase()) {
    case "config":
      return Object.assign({}, state, {
        [action.key]: action.value
      })
    default:
      return state
  }
}

function translationsStateReducer(state = {}, action) {
  switch (action.type.toLowerCase()) {
    case "translations":
      return Object.assign({}, state, {
        [action.key]: action.value
      })
    default:
      return state
  }
}

const stateReducer = combineReducers({
  data: dataStateReducer,
  config: configStateReducer,
  translations: translationsStateReducer
})

let storeInstance = null;
let language = "en";

export default class Storage {

  static getStore() {
    if(!storeInstance){
      storeInstance = createStore(stateReducer);
    }
    return storeInstance;
  }
  
  // Config
  static setConfig(configKey, config) {
    this.getStore().dispatch({
      type: "config", 
      key: configKey, 
      value: config
    });
  }
  static getConfig(configKey) {
    const config = this.getStore().getState()["config"][configKey];
    if (config && config.config) {
      config.config.preset = true;
    }
    return config;
  }
  static getConfigKeys() {
    return Object.keys(this.getStore().getState()["config"]);
  }

  // Translations
  static setTranslations(langKey, config) {
    this.getStore().dispatch({
      type: "translations",
      key: langKey, 
      value: config
    });
  }
  static setLanguage(lang) {
    language = lang;
  }
  static getTranslation(key) {
    return this.getStore().getState()["translations"][language][key];
  }
  
}

export function T(key) {
  return Storage.getTranslation(key);
}


// WEBPACK FOOTER //
// ./src/Storage.js